import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import {
	compareModalSearchResultAvatarClassName,
	searchResultAvatarClassName
} from '../../../utils/avatarClassNames';

const TeamSearchBarResultsList = ({
	teams,
	handleTeamClick,
	isCompareModal
}) => {
	const { isDarkMode } = useTheme();

	const avatarClassName =
		isCompareModal && isDarkMode
			? compareModalSearchResultAvatarClassName
			: searchResultAvatarClassName;

	if (teams.length === 0) return null;

	return (
		<div
			className="absolute bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border mt-2 p-2 rounded-md shadow-lg z-30 max-h-64 overflow-y-auto text-gray-800 dark:text-dark-text"
			style={{ top: '50px', left: '30px' }}
		>
			<ul>
				{teams.map((team) => (
					<li
						key={team.id}
						className="p-2 cursor-pointer flex items-center rounded-md hover:bg-gray-100 dark:hover:bg-dark-bg"
						onClick={() => handleTeamClick(team)}
					>
						<div className="hidden sm:block">
							<img
								className={avatarClassName}
								src={`${team.image_url}?w=50&h=50`}
								alt={`${team.name}`}
								style={{
									width: 50,
									height: 50,
									objectFit: 'cover'
								}}
							/>
						</div>
						<span className="hover:underline text-xs md:text-base">
							{team.name}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
};

export default TeamSearchBarResultsList;
